import React from 'react';
import PropTypes from 'prop-types';

import { Decline } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const Blocked = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <Decline className="mb-4" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-8">
        Unfortunately, your <br/>application was not <br/>approved at this time.
      </p>
    </div>
  );
};

Blocked.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default Blocked;
